import React from 'react';
import { Link } from 'react-router-dom';


const Gallery = props => {
    const projectList = props.projects.map(project => {
        return(
            <div key={project.id} className="gallery__item" style={{backgroundImage: `url(${project.img})`}}>
                <Link to={`/project/${project.id}`} className="gallery__link">
                    <span className="gallery__title">{project.name}</span>
                </Link>
            </div>
        )
    })
    return(
        <div className="gallery">
           {projectList}
        </div>
    );
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Gallery.js